module.exports = __webpack_public_path__ + "static/img/pic4-t.afc090c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/pic4-t.png
// module id = aSYf
// module chunks = 0